import React from "react"
import classnames from "classnames"
import styles from "./AccessoryDetails.less"
import {
  ColumnGroup,
  H4,
  H6,
  BackButton,
  Space,
  Content,
  Section,
  StarIcon,
  Caption
} from 'AtomicComponents'
import {
  HeroContent,
  Image,
  Slideshow,
  Disclaimer
} from "AtomicContainers"
import cookieHandler from "AtomicUtils/cookieHandler"

class AccessoryDetails extends React.Component {
  render() {
    const {
      name,
      description,
      generalDisclaimer,
      priceText,
      packNumber,
      partNumber,
      backUrl = '/accessories',
      media
    } = this.props

    let cookieHandlerObject = new cookieHandler()
    let history = cookieHandlerObject.getCookie("history")
    let found = false

    if (history) {
      let newHistory = JSON.parse(history)

      if (newHistory && newHistory.length > 0) {
        if (newHistory[newHistory.length - 1].indexOf(backUrl) !== -1) {
          found = true
        }
      }
    }

    return (
      <div
        className={classnames({
          [styles.AccessoryDetails]: true,
      })}>
        <BackButton
          href={found ? 'javascript:history.back()' : backUrl}
          backText="BACK TO ACCESSORIES"
        />
        <HeroContent
          heading={`MAZDA ${packNumber ? 'ACCESSORY PACKS' : 'ACCESSORIES'}`}
        />
        <Space />
        <Section padding center={false}>
          <ColumnGroup center={false}>
            <Section horizontalPadding center={false}>
              <Space />
              <H4 withDetails>
                {name}
              </H4>
              <Space />
              <H6 withDetails>
                {priceText}
                <Disclaimer text={"*"}>
                  {generalDisclaimer}
                </Disclaimer>
              </H6>
              <Space />
              <Content xmlString={description} textAlign="left" />
              <Space />
              <hr />
              {partNumber &&
                <Caption>
                  PART NUMBER: {partNumber}
                </Caption>
              }
              {packNumber &&
                <Caption>
                  PACK NUMBER: {packNumber}
                </Caption>
              }
            </Section>
            <div className={classnames({
                [styles.width100]: true,
            })}>
              {media && media.length > 1 &&
                <Slideshow
                  slides={media.map((item,index)=>{
                    return {
                      name: `name-${index}`,
                      imageSrc: item.imageUrl,
                      youtubeId: item.videoId,
                      youtubeLink: item.videoUrl
                    }
                  })}
                />
              }
              {media && media.length == 1 &&
                <Image src={media[0].imageUrl} />
              }
            </div>
          </ColumnGroup>
        </Section>
        <Space />
        <Space />
      </div>
    )
  }
}

export default AccessoryDetails



// WEBPACK FOOTER //
// ./src/AtomicContainers/AccessoryDetails/AccessoryDetails.jsx